import React, { Component } from 'react'
import Slider from 'react-slick'
import styles from './GalleryModal.css'
import Vimeo from '../../Vimeo'
import Modal from '../../Modal'
import Rx from 'rxjs/Rx'
import ScrollArrow from '../../ScrollArrow'

import "../../../../../node_modules/slick-carousel/slick/slick.css";
import "../../../../../node_modules/slick-carousel/slick/slick-theme.css";


export default class GalleryModal extends Component {
  componentDidMount () {
    const key$ = Rx.Observable.fromEvent(document, 'keydown')

    const leftKey$ = key$.filter(e => e.keyCode === 37)
    this.leftSubscription = leftKey$.subscribe(() => this.slider.slickPrev())

    const rightKey$ = key$.filter(e => e.keyCode === 39)
    this.rightSubscription = rightKey$.subscribe(() => this.slider.slickNext())
  }

  componentWillUnmount () {
    this.leftSubscription.unsubscribe()
    this.rightSubscription.unsubscribe()
  }

  render () {
    var settings = {
      infinite: true,
      dots: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: styles.dots,
      initialSlide: this.props.initialSlide,
      nextArrow: <NextArrow/>,
      prevArrow: <PrevArrow/>,
    }
    return (
      <Modal quitModal={this.props.quitModal}>
        <div className={styles.carousel}>
          <Slider ref={x => {this.slider = x}} {...settings}>
            {
              this.props.gallery.map( (item, k) => <Item key={k} k={k} {...item}/> )
            }
          </Slider>
        </div>
      </Modal>
    )
  }
}

class Item extends Component {
  scrollToDesc = () => {
    const offset = this.slideDesc.offsetTop
    var dT = 1/30
    var x;
    var x_0 = this.scrollCont.scrollTop;
    var D = offset-this.scrollCont.scrollTop;
    var t = 0;
    var T = 0.5; // total time in seconds
    const scrollCont = this.scrollCont
    function dit () {
      x = x_0 + D*(0.5-0.5*Math.cos(3.14/T*t));
      t += dT;
      scrollCont.scrollTop = x;
      if (t < T) {
        requestAnimationFrame(dit);
      }
    }
    dit();
  }

  render () {
    return (
      <div
        className={'slick-slide '+styles.slide}
        data-index={this.props.k}
        style={{
          width: document.body.scrollWidth,
          height: window.innerHeight,
        }}
      >
        <div className={styles.scrollContOuter}
          style={{
            width: document.body.scrollWidth - (window.innerWidth < 730 ? 0 : 120),
            height: window.innerHeight - 120,
          }}
        >
          <div className={styles.scrollCont} ref={scrollCont => {this.scrollCont = scrollCont}}>
            <div
              style={{
                width: document.body.scrollWidth - (window.innerWidth < 730 ? 0 : 120),
                height: window.innerHeight - 120,
              }}
            >
              {
                this.props.video ? (
                  <div className={styles.img}>
                    <Vimeo video={this.props.video} image={this.props.image}/>
                  </div>
                ) : this.props.image && (
                  <div
                    className={styles.img}
                    style={{
                      backgroundImage: 'url('+this.props.image+')'
                    }}
                  />
                )
              }
              <div className={styles.scrollArrowCont}>
                <ScrollArrow onClick={this.scrollToDesc}/>
              </div>
              <div className={styles.slideDesc} ref={slideDesc => {this.slideDesc = slideDesc}}>
                <div
                  className={styles.body}
                  dangerouslySetInnerHTML={{__html: this.props.description}}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.caption}>
          <div className={styles.primaryTitle}>{this.props.primaryTitle}</div>
          {this.props.year && (<div className={styles.year}>, {this.props.year}</div>)}
          {this.props.secondaryTitle && (<div className={styles.secondaryTitle}>, {this.props.secondaryTitle}</div>)}
        </div>

      </div>
    )
  }
}



class NextArrow extends Component {
  render () {
    return (
      <div
        className={styles.nextArrow}
        onClick={this.props.onClick}
        style={this.props.style}
      />
    )
  }
}

class PrevArrow extends Component {
  render () {
    return (
      <div
        className={styles.prevArrow}
        onClick={this.props.onClick}
        style={this.props.style}
      />
    )
  }
}




// WEBPACK FOOTER //
// ./src/Rist/modules/Gallery/GalleryModal/index.js